// Função utilitária para envio de interesse no extrator de dados
// Reutiliza a mesma infraestrutura do feedback

export async function sendExtractorInterest({ email, tool, customTool }) {
  // URL da API - funciona tanto local quanto no Vercel
  const apiUrl = process.env.NODE_ENV === 'production' 
    ? '/api/extractor-interest'  // Vercel Functions
    : 'http://localhost:3002/api/extractor-interest'; // Desenvolvimento local

  const data = {
    email,
    tool,
    customTool: tool === 'outros' ? customTool : null,
    timestamp: new Date().toISOString(),
    type: 'extractor-interest'
  };


  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });


    if (!response.ok) {
      // Capturar mais detalhes do erro
      const errorText = await response.text();
      console.error('❌ Erro na API:', response.status, errorText);
      throw new Error(`Erro ao enviar interesse: ${response.status} - ${errorText}`);
    }
    
    const result = await response.json();
    
    return true;
  } catch (error) {
    console.error('❌ Erro na requisição:', error);
    throw error;
  }
}
